
    import './styles.scoped.css';
    export default {
  "breadcrumb-group": "awsui_breadcrumb-group_d19fg_1tpcb_93",
  "item": "awsui_item_d19fg_1tpcb_129",
  "breadcrumb-group-list": "awsui_breadcrumb-group-list_d19fg_1tpcb_164",
  "ellipsis": "awsui_ellipsis_d19fg_1tpcb_174",
  "icon": "awsui_icon_d19fg_1tpcb_182",
  "mobile": "awsui_mobile_d19fg_1tpcb_186",
  "mobile-short": "awsui_mobile-short_d19fg_1tpcb_199"
};
  